import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgBoltSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12 6.95001H8.92V1L4 9.04999H7.17V15L12 6.95001Z"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgBoltSmall.displayName = 'SvgBoltSmall';
const BoltSmall = withForgeIconProps(SvgBoltSmall, {
  name: 'Bolt',
  usage: 'Use to trigger accelerators, like macros and templates.',
  related: 'shortcut, lightning, accelerate',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default BoltSmall;
